/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acted Core API
 * Core backend API.
 * OpenAPI spec version: 1.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  WorkflowsRenderPngRetrieveParams
} from '../model';

import {
  environment
} from 'environments/environment';



import { filterParams, HttpClientBodyOptions, HttpClientEventOptions, HttpClientObserveOptions, HttpClientResponseOptions } from '../httpClientOptions';

@Injectable({ providedIn: 'root' })
export class WorkflowsService {
  private readonly http = inject(HttpClient);
/**
 * Render this Workflow via a PNG image.
 */
 retrieve(name: string,
    params?: WorkflowsRenderPngRetrieveParams, options?: HttpClientBodyOptions): Observable<Blob>;
 retrieve(name: string,
    params?: WorkflowsRenderPngRetrieveParams, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 retrieve(name: string,
    params?: WorkflowsRenderPngRetrieveParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  retrieve(
    name: string,
    params?: WorkflowsRenderPngRetrieveParams, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get(
      `${environment.apiRoot}/api/workflows/${name}/render-png/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `${environment.apiRoot}/api/workflows/${name}/render-png/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `${environment.apiRoot}/api/workflows/${name}/render-png/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    ) as Observable<Blob>;
  }
};

